export const userGZA= 'gazetadealagoas';
export const passwordGZA ='gza2019';
